import React from "react";

const colors = {
    primary: { main: "#c50000", contrastText: "#fff" },
    secondary: { main: "#9c27b0", contrastText: "#fff" },
    success: { main: "#2e7d32", contrastText: "#fff" },
    error: { main: "#d32f2f", contrastText: "#fff" },
};

const sizes = {
    small: { padding: "4px 10px", fontSize: "0.75rem" },
    medium: { padding: "7px 16px", fontSize: "0.875rem" },
    large: { padding: "8px 22px", fontSize: "0.9375rem" },
};

const CustomButton = React.forwardRef(function CustomButton(props, ref) {
    const {
        children,
        color = "primary",
        variant = "contained",
        size = "medium",
        disabled = false,
        onClick,
        className = "",
        style = {},
        type,
        fullWidth = false,
        startIcon,
        endIcon,
        ...rest
    } = props;

    const buttonType = typeof type === "undefined" ? "button" : type;
    const selectedColor = colors[color] || colors.primary;
    const selectedSize = sizes[size] || sizes.medium;

    const baseStyles = {
        fontWeight: 500,
        borderRadius: 4,
        border: "1px solid transparent",
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "all 0.2s ease",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 64,
        ...selectedSize,
    };

    const variantStyles = {
        contained: {
            backgroundColor: selectedColor.main,
            color: selectedColor.contrastText,
            border: "none",
        },
        outlined: {
            backgroundColor: "transparent",
            color: selectedColor.main,
            border: `1px solid ${selectedColor.main}`,
        },
        text: {
            backgroundColor: "transparent",
            color: selectedColor.main,
            border: "none",
            padding: selectedSize.padding.replace(
                /\d+px/g,
                (m) => `${parseInt(m) - 2}px`
            ),
        },
    };

    const finalStyle = {
        ...baseStyles,
        ...(variantStyles[variant] || variantStyles.contained),
        ...(disabled && {
            backgroundColor: "#f5f5f5",
            color: "#9e9e9e",
            border: "1px solid #e0e0e0",
            cursor: "not-allowed",
            pointerEvents: "none", // 🔑 disables hover entirely
        }),
        opacity: disabled ? 0.6 : 1,
        ...(fullWidth && { width: "100%" }),
        ...style,
    };

    return (
        <button
            ref={ref}
            type={buttonType}
            className={className}
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
            style={finalStyle}
            {...rest}
        >
            {startIcon && <span className="mr-2">{startIcon}</span>}
            {children}
            {endIcon && <span className="ml-2">{endIcon}</span>}
        </button>
    );
});

export default CustomButton;
